(function ($, Drupal) {
  // Header behaviors (Sticky, scroll direction...)
  Drupal.behaviors.addGwp = {
    attach(context, settings) {
      $('.gwp__gift--not-added').on('click', function () {
        if ($(this).hasClass('gwp__temporary')) {
          $(this).removeClass('gwp__temporary');
        }
        else if (!$(this).hasClass('gwp__added')) {
          $(this).removeClass('gwp__temporary');
          $(this).addClass('gwp__temporary');
          const addToCart = $('a.gwp__add').attr('href');
          const addButton = $('a.gwp__add');
          addButton.attr('href', addToCart);
        }
        if ($(this).hasClass('gwp__aded')) {
          const selectedProduct = $('added-info').text();
        }
      });
    },
  };
}(jQuery, Drupal));
